'use strict';

define(function (require, exports, module) {
    const headerEl = document.querySelector('.header');
    if (!headerEl) {
        return;
    }

    const headerNav = headerEl.querySelector('.header__navigation') || {};
    const mobileNavIcon = headerEl.querySelector('.header__hamburger') || {};
    const secondaryNav =
        headerNav.querySelector('.header__nav-items--secondary') || {}; // Search
    const search = headerEl.querySelector('.header__search');
    const searchHandler =
        (search && search.querySelector('.search__handler')) || {};
    const searchClose =
        (search && search.querySelector('.search__close')) || {};
    const searchInput =
        (search && search.querySelector('.header__search-bar')) || {};
    const suggestions =
        (search && search.querySelector('.search__suggestions')) || {}; // const searchSeeAll = search.querySelector('.search__see-all');

    const headerUtils = require('./headerUtils');
    const lodash = require('lodash');

    const { mlbstatic = 'https://www.mlbstatic.com' } =
        window.server_path || {};

    let masterList;

    const fetchedTypes = [];

    window.milbSearch = {};

    if (search) {
        // open search input
        searchHandler.addEventListener('click', function (e) {
            if (mobileNavIcon.offsetParent !== null) {
                if (headerEl.classList.contains('open')) {
                    headerUtils.toggleMobileMenu();
                }
                headerUtils.toggleNoScroll();
            }
            search.classList.add('open');
            secondaryNav.classList.add('expand');
            searchInput.value = '';
            searchInput.focus();
            e.stopPropagation();
        });
        searchClose.addEventListener('click', function () {
            headerUtils.closeSearch();
        });
        searchInput.addEventListener('click', function (e) {
            e.stopPropagation();
        });

        let timeout;
        searchInput.addEventListener('input', function () {
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                dataCall(searchInput.value);
            }, 100);
        });
        search.addEventListener('keyup', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
            } else if (e.keyCode === 27) {
                headerUtils.closeSearch();
                fetchedTypes.length = 0;
            }
        });

        // close search on outside input click
        document.addEventListener('click', function () {
            if (search.classList.contains('open')) {
                headerUtils.closeSearch();
                fetchedTypes.length = 0;
            }
        });
    }

    function findMatches(wordToMatch, list) {
        // store item IDs in a set to prevent duplicate matches
        const matches = new Set();
        const itemReturn = list.filter(function (item) {
            const { id, matchName = '', primary } = item;
            if (matches.has(id)) {
                return false;
            }

            const regex = new RegExp(lodash.deburr(wordToMatch), 'gi');
            return (
                (matchName.match(regex) || primary.match(regex)) &&
                matches.add(id)
            );
        });
        return itemReturn;
    }

    function displayMatches(array, type) {
        masterList = masterList.concat(array);
        fetchedTypes.push(type);

        // @TODO: replace with promises
        if (fetchedTypes.length < 3) {
            return;
        }

        const { value = '' } = searchInput;

        const matchArray = findMatches(value, masterList);

        const html = matchArray
            .map((item) => {
                const playerName = item.primary;
                const regex = new RegExp(value, 'gi');
                // highlights search value within item
                const itemName = playerName.replace(
                    regex,
                    `<span class="hl">${value}</span>`,
                );

                let avatar = '';
                let slug = '';
                let url = '';
                if (item.type === 'player') {
                    slug = `player/${item.nameSlug || item.id}`;
                    avatar = `https://img.mlbstatic.com/mlb-photos/image/upload/d_headshot_silo_generic.png,w_60/v1/people/${item.id}/headshot/milb/current`;
                } else if (item.type === 'league') {
                    slug = window.MilbUtils.leagueIdToSlugMap[item.id];
                    avatar = `${mlbstatic}/team-logos/league-on-light/${item.id}.svg`;
                } else if (item.type === 'team') {
                    slug = window.MilbUtils.teamIdToSlugMap[item.id];
                    avatar = `${mlbstatic}/team-logos/${item.id}.svg`;
                }

                url = `${window.location.origin}/${slug}`;

                const playerInfo =
                    item.secondary && item.tertiary
                        ? `<div class="search__result-secondary">${item.secondary}, (${item.tertiary})</div>`
                        : '';

                return `<a href="${url}" class="search__result-link">
                            <span class="search__result-img">
                                <img src="${avatar}">
                            </span>
                            <span class="search__result-item">
                                <div class="search__result-primary">${itemName}</div>${playerInfo}
                            </span>
                        </a>`;
            })
            .join('');
        suggestions.innerHTML = html;
        suggestions.classList.add('has-suggestions'); // const seeAllMessage = `See all News for <span>${value}</span>`;

        // searchSeeAll.innerHTML = seeAllMessage;
        // searchSeeAll.setAttribute('href', `${contextUrlPrefix}/news/search?q=${value}&type=article&pageId=search&page=1`);
        // const suggestionsHeight = suggestions.offsetHeight;
        // set max height on suggestions for mobile

        var documentHtmlClasslist =
            document.querySelector('html') &&
            document.querySelector('html').classList;

        if (
            documentHtmlClasslist.contains('device-phone') ||
            documentHtmlClasslist.contains('device-tablet')
        ) {
            const headerHeight = headerNav.clientHeight;
            const searchInputHeight = searchInput.clientHeight;
            const totalHeaderHeight = headerHeight + searchInputHeight;
            const mobileMenuHeight = `${window.innerHeight - totalHeaderHeight}px`;
            suggestions.style.maxHeight = mobileMenuHeight;
        }

        let fnAdjustResultPlacements;

        if (value === '') {
            suggestions.innerHTML = '';
            suggestions.classList.remove('has-suggestions');
            //searchSeeAll.style.visibility = 'hidden';
        }

        fnAdjustResultPlacements = function adjustResultPlacements(x) {
            if (x.matches) {
                // If media query matches aka mobile
                if (suggestions.innerHTML === '') {
                    // searchClose.style.display = 'none';
                } else {
                    suggestions.style.visibility = 'visible';
                }
            }
        };

        const x = window.matchMedia('(max-width: 1024px)');
        fnAdjustResultPlacements(x);
        x.addListener(fnAdjustResultPlacements);
    }

    function fetchLeagues() {
        const leaguesEndpoint =
            'https://statsapi.mlb.com/api/v1/league?leagueIds=109,110,111,112,113,116,117,118,120,121,122,123,124,125,126,127,128,130';
        return fetch(leaguesEndpoint)
            .then((blob) => blob.json())
            .then((data) => {
                const type = 'league';
                const leagues = data.leagues.map((league) => {
                    return {
                        primary: league.name,
                        id: league.id,
                        type,
                    };
                });
                window.milbSearch.leagues = leagues;
                return leagues;
            });
    }

    function fetchPlayers(searchString) {
        const playersEndpoint = `https://statsapi.mlb.com/api/v1/people/search?names=${searchString}&sportIds=11,12,13,14,15,5442,16&active=true&hydrate=currentTeam,team`;
        return fetch(playersEndpoint)
            .then((blob) => blob.json())
            .then((data) => {
                const type = 'player';
                const { people = [] } = data;
                // filter for active but should be covered by statsapi call to be fixed in offseason season
                // https://mlbam.slack.com/archives/C3PKP1VPC/p1664891676427789?thread_ts=1664889479.672639&cid=C3PKP1VPC
                // sort results by firstLastName
                return people
                    .filter((p) => p.active)
                    .sort((a, b) =>
                        a.firstLastName.localeCompare(b.firstLastName),
                    )
                    .map((player) => {
                        const {
                            currentTeam = {},
                            firstLastName = '',
                            nameFirstLast = '',
                            id,
                            nameSlug = '',
                        } = player;
                        const {
                            abbreviation = '',
                            parentOrgId,
                            shortName = '',
                        } = currentTeam;
                        const parentOrg =
                            parentOrgId && window.milbSearch.mlbTeams
                                ? window.milbSearch.mlbTeams.find(
                                      (t) => t.id === parentOrgId,
                                  )
                                : {};
                        const { abbreviation: parentOrgAbbr = '' } =
                            parentOrg || {};

                        return {
                            primary: firstLastName,
                            secondary: shortName,
                            tertiary: parentOrgAbbr || abbreviation,
                            matchName: nameFirstLast,
                            id,
                            type,
                            nameSlug,
                        };
                    });
            });
    }

    function fetchTeams(sport) {
        const sportIds = sport === 'milb' ? '11,12,13,14,15,5442' : '1';
        const teamsEndpoint = `https://statsapi.mlb.com/api/v1/teams?sportIds=${sportIds}`;
        return fetch(teamsEndpoint)
            .then((blob) => blob.json())
            .then((data) => {
                // fetch MLB teams for parentOrg details
                if (sport === 'mlb') {
                    const { teams = [] } = data;
                    if (teams.length) {
                        window.milbSearch.mlbTeams = teams;
                    }
                    return teams;
                }
                /**
                 * Fetch MiLB Teams
                 */
                const teams = data.teams.map((team) => {
                    const { id, name } = team || {};
                    return {
                        primary: name,
                        id,
                        type: 'team',
                    };
                });

                window.milbSearch.teams = teams;
                return teams;
            });
    }

    // fetch mlb teams on load
    if (!window.milbSearch.mlbTeams) {
        fetchTeams('mlb');
    }

    function dataCall(searchString) {
        if (searchString.length < 3) {
            suggestions.innerHTML = '';
            return;
        }

        masterList = [];

        const { milbSearch = {} } = window;
        const { teams: milbTeams, leagues: milbLeagues } = milbSearch;

        // search players
        fetchPlayers(searchString).then((players) =>
            displayMatches(players, 'player'),
        );

        // search teams and display results
        if (!milbTeams) {
            fetchTeams('milb').then((teams) => displayMatches(teams, 'team'));
        } else {
            displayMatches(milbTeams, 'team');
        }

        // search leagues and display results
        if (!milbLeagues) {
            fetchLeagues().then((leagues) => displayMatches(leagues, 'league'));
        } else {
            displayMatches(milbLeagues, 'league');
        }
    }
});
